import { render, staticRenderFns } from "./BusinessManagement.vue?vue&type=template&id=28420d7e&"
import script from "./BusinessManagement.vue?vue&type=script&lang=js&"
export * from "./BusinessManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports